import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import { RowContainer } from 'app/components/Facility/FacilityDetails/FacilityTabs/CustomComponents/styles';
import { Row, RowHead } from '../../ProfileTab/Cards/styles';
import { Checkbox, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import HalfwayIcon from 'app/assets/images/CandidateProfile/Halfway.svg';
import ErrorOutline from 'app/assets/images/CandidateProfile/error_outline-24px.svg';
import { theme } from 'styles/global-styles';
import { useStyes } from './styles';
import { rowSectionProps } from './types';
import { getWarningColor } from './helper';

export const RowSection: React.FC<rowSectionProps> = props => {
  const { classes } = useStyes();

  return (
    <LayoutGridItem style={{ width: '100%' }} sx={{ paddingLeft: '3px' }}>
      <RowContainer>
        <Row>
          <RowHead style={{ wordBreak: 'keep-all', whiteSpace: 'normal' }}>
            <div className={classes.normalText}>
              <LayoutGrid direction="row" wrap="nowrap" spacing={0} alignItems="flex-start">
                <LayoutGridItem>
                  {!props.showHalfwayProgress ? (
                    <Checkbox
                      disableFocusRipple
                      disableRipple
                      disabled={true}
                      className={`${classes.inlineBoxEditItemPadding} ${classes.inlineBoxEditMainCheckItem}`}
                      icon={
                        !props.showAlert ? (
                          props.preData !== '' || props.preData === true ? (
                            <CheckCircleIcon style={{ color: props.color }} />
                          ) : (
                            <CircleUnchecked />
                          )
                        ) : (
                          <ErrorOutlinedIcon style={{ color: theme.palette.system.crimson }} />
                        )
                      }
                      checkedIcon={<CheckCircleIcon />}
                    />
                  ) : (
                    <Checkbox
                      disableFocusRipple
                      disableRipple
                      disabled={true}
                      className={`${classes.inlineBoxEditItemPadding} ${classes.inlineBoxEditMainCheckItem}`}
                      icon={
                        !props.showHalfwayProgressSecondaryIcon ? (
                          <img src={HalfwayIcon} alt="Halfway" style={{ paddingLeft: 1 }} />
                        ) : (
                          <img src={ErrorOutline} alt="Error" className={classes.yellowAlert} />
                        )
                      }
                      checkedIcon={<CheckCircleIcon />}
                    />
                  )}
                </LayoutGridItem>
                <LayoutGridItem>
                  <div className={`${classes.inlineBoxEditMainLblItem}`}>
                    <span>{props.header}</span>
                    {props.warningMessage && (
                      <>
                        <Typography gutterBottom component="span" style={{ padding: '0 5px' }}>
                          {`•`}
                        </Typography>
                        <Typography
                          gutterBottom
                          component="span"
                          style={{ color: getWarningColor(props.warningMessage) }}
                        >
                          {props.warningMessage}
                        </Typography>
                      </>
                    )}
                  </div>
                </LayoutGridItem>
              </LayoutGrid>
            </div>
          </RowHead>
        </Row>
      </RowContainer>
      {props.children}
    </LayoutGridItem>
  );
};
